import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AccessibilitySkipLink from './components/AccessibilitySkipLink';
import { AuthProvider } from './components/auth/AuthProvider';
import Home from './pages/Home';
import MyAccount from './pages/MyAccount';
import Login from './pages/Login';
import Signup from './pages/Signup';
import DatabaseTest from './pages/DatabaseTest';

const App = () => {
  // Override browser's scroll restoration globally
  React.useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    // Add global error handler for unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Prevent the default browser behavior
      event.preventDefault();
    };
    
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return (
    <AuthProvider>
      <HelmetProvider>
        <Helmet>
          <title>SafePlay AI</title>
          <meta name="description" content="AI-powered gaming safety platform that protects children from online threats while preserving the joy of gaming." />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="theme-color" content="#064e3b" />
        </Helmet>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-800">
            <AccessibilitySkipLink />
            <Navigation />
            <ScrollToTop />
            <main id="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/my-account" element={<MyAccount />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/database-test" element={<DatabaseTest />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </HelmetProvider>
    </AuthProvider>
  );
};

export default App;